import { requestBffApi, apiPaths, handleResponse } from '../../config';

export const hardcodedSettingsServices = {
    getSuperAdmins
};

function getSuperAdmins () {
    return requestBffApi(apiPaths.hardcodedSettings.superAdmins).then(handleResponse);
}
